<template>
  <div class="form-detail">
    <h1 class="ml-1 form-inner-heading d-inline-flex justify-content-between align-items-center">
      <span>File biên bản bàn giao - {{ item.code }}</span>
    </h1>
    <div class="flex-wrap d-block" style="gap: 10px">
      <!-- :maxFile="1" -->
      <UploadMultiple
        v-if="item.urlPDF"
        :lsData="[item]"
        keyUrl="urlPDF"
        :canUpload="false"
        :title="`File biên bản ${item.code}`"
      />
      <UploadMultiple
        v-if="item.appendixHandOver.proofImages.length > 0"
        :lsData="item.appendixHandOver.proofImages"
        :canUpload="false"
        :title="'Ảnh chụp live'"
      />
      <UploadMultiple
        v-if="item.appendixHandOver.explanationImages.length > 0"
        :lsData="item.appendixHandOver.explanationImages"
        :canUpload="false"
        title="Ảnh giải trình"
      />
      <span v-if="item.appendixHandOver.explanation"
        >Giải trình: {{ item.appendixHandOver.explanation }}</span
      >
    </div>
  </div>
</template>
<script>
  import UploadMultiple from '@/components/UploadMultiple.vue'

  export default {
    props: {
      item: {
        type: Object,
        default: () => {},
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { UploadMultiple },
  }
</script>

<style scoped></style>
